import styled, { css } from 'styled-components';
import { Flex } from '../../../../layout/Flex';
import { BusinessStatisticSectionProps } from './types';

export const BusinessStatisticSectionFlex = styled(Flex)
    .withConfig({ displayName: 'BusinessStatisticSection' })
    .attrs<BusinessStatisticSectionProps>((props) => ({
        ...props,
        borderTop: '1px solid var(--divider)',
    }))`
        ${(props) =>
            !props.isMobile &&
            css`
                &:nth-child(odd) {
                    border-right: 1px solid var(--divider);
                }
            `}
    `;
